import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonNav, ModalController } from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';
import { CommonService } from 'src/app/services/common.service';
import { AddressDetailsPage } from '../../../../address-details/address-details.page';

interface RepayApiResponse {
  result: string;
  message: string;
}

@Component({
  selector: 'app-repay-ach',
  templateUrl: './repay-ach.page.html',
  styleUrls: ['./repay-ach.page.scss'],
})
export class RepayAchPage implements OnInit {
  @Input() caseId;
  @Input() responseData;
  @Input() debtorDetails;
  title = 'Lateral Payment Portal';
  repayAchForm: FormGroup;
  saveBtnDisabled = false;
  isConfigured = false;
  amount = 0;
  fieldLabels = {};
  checkoutFormId: string;
  paytoken: string;
  waive_conv_fee = true;
  billingAddress = [];
  selectedBillingAddress;

  constructor(
    private formBuilder: FormBuilder,
    private caseService: CaseService,
    private commonService: CommonService,
    private ionNav: IonNav,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.saveBtnDisabled = false;
    this.amount = this.responseData?.net_amount;
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.payment_type) {
      let payment_type = portalSettings?.payment_type
        ? portalSettings?.payment_type
        : {};
      if (payment_type?.repay && payment_type?.repay?.label) {
        this.title = payment_type.repay.label;
      }
    }
    if (portalSettings?.fieldLabels) {
      this.fieldLabels = portalSettings.fieldLabels;
    }
    this.isConfigured = true;
    this.initForm();
    console.log(this.debtorDetails);
    this.updateFormData(this.debtorDetails);
  }

  initForm() {
    this.repayAchForm = this.formBuilder.group({
      amount: [
        { value: this.amount ? this.amount : 0, disabled: true },
        [Validators.required],
      ],
      first_name: [this.debtorDetails?.debtor_1_name || '', [Validators.required]],
      last_name: [this.debtorDetails?.debtor_1_surname || '', [Validators.required]],
      channel_user: [
        this.debtorDetails?.emails[0].account || '',
        [Validators.required],
      ],
      account_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{3,17}$')],
      ],
      routing_number: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{9}$')],
      ],
      account_type: ['checking', [Validators.required]],
      address_ln1: [
        this.debtorDetails?.addresses[0]?.address_ln1
          ? this.debtorDetails.addresses[0]?.address_ln1
          : '',
        [Validators.required],
      ],
      address_ln2: [
        this.debtorDetails?.addresses[0]?.address_ln2
          ? this.debtorDetails.addresses[0]?.address_ln2
          : '',
        [],
      ],
      address_ln3: [
        this.debtorDetails?.addresses[0]?.address_ln3
          ? this.debtorDetails.addresses[0]?.address_ln3
          : '',
        [],
      ],
      address_town: [
        this.debtorDetails?.addresses[0]?.address_town
          ? this.debtorDetails.addresses[0]?.address_town
          : '',
        [Validators.required],
      ],
      address_postcode: [
        this.debtorDetails?.addresses[0]?.address_postcode
          ? this.debtorDetails.addresses[0]?.address_postcode
          : '',
        [Validators.required],
      ],
    });
  }

  updateFormData(data) {
    if (!data) return;

    const updatedValues = {
      first_name: data.debtor_1_name || '',
      last_name: data.debtor_1_surname || '',
      channel_user: data.emails[0].account || '',
      address_ln1: data?.addresses[0]?.address_ln1 || '',
      address_ln2: data?.addresses[0]?.address_ln2 || '',
      address_ln3: data?.addresses[0]?.address_ln3 || '',
      address_town: data?.addresses[0]?.address_town || '',
      address_postcode: data?.addresses[0]?.address_postcode || '',
    };

    Object.keys(updatedValues).forEach((key) => {
      if (this.repayAchForm.controls[key]) {
        this.repayAchForm.controls[key].setValue(updatedValues[key]);
      }
    });

    if (data.addresses && data.addresses.length > 0) {
      this.billingAddress = data.addresses.map((add) => {
        return this.getBillingAddress(add);
      });
      if (this.billingAddress[0]) {
        this.selectedBillingAddress = this.billingAddress[0];
      }
    }
  }

  getBillingAddress(add) {
    const address_ln1 = add?.address_ln1 ? add?.address_ln1 + ', ' : '';
    const address_ln2 = add?.address_ln2 ? add?.address_ln2 + ', ' : '';
    const address_ln3 = add?.address_ln3 ? add?.address_ln3 + ', ' : '';
    const address_town = add?.address_town ? add?.address_town + ', ' : '';
    const address_postcode = add?.address_postcode ? add?.address_postcode : '';
    return address_ln1 + address_ln2 + address_ln3 + address_town + address_postcode;
  }

  isAddressMissing() {
    const value = this.repayAchForm.value;
    return !value['address_town'] || !value['address_postcode'] || !value['address_ln1'];
  }

  async changeAddress() {
    const values = this.repayAchForm.value;
    const address = {
      address_ln1: values.address_ln1,
      address_ln2: values.address_ln2,
      address_ln3: values.address_ln3,
      address_town: values.address_town,
      address_postcode: values.address_postcode,
    };
    const requiredAddress = {
      address_ln1: true,
      address_town: true,
      address_postcode: true,
    };
    const modal = await this.modalController.create({
      component: AddressDetailsPage,
      componentProps: {
        address,
        requiredAddress,
        setAddress: (data) => {
          Object.keys(data).forEach((key) => {
            if (this.repayAchForm.controls[key]) {
              this.repayAchForm.controls[key].setValue(data[key]);
            }
          });
        },
      },
    });
    return await modal.present();
  }

  async getCheckoutFormId() {
    if (this.repayAchForm.invalid) {
      return;
    }

    this.saveBtnDisabled = true;
    this.commonService.showLoader('Processing...');

    const checkoutFormData = {
      payment_method: 'ach',
      transaction_type: 'sale',
      source: 'Lateral DAPI'
    };

    try {
      const response = await this.caseService.getRepayCheckoutForm(checkoutFormData).toPromise() as RepayApiResponse;

      if (response?.result) {
        this.checkoutFormId = response.result;
        this.commonService.dismissLoader();
        await this.getPayToken();
      }
      else {
        this.commonService.showToast(response?.message || 'Failed to get checkout form', 'danger');
      }
    }
    catch (error) {
      console.error('Error getting checkout form:', error);
      this.commonService.showToast('Failed to process payment request', 'danger');
    }
    finally {
      this.saveBtnDisabled = false;
      this.commonService.dismissLoader();
    }
  }

  async getPayToken() {
    this.saveBtnDisabled = true;
    this.commonService.showLoader('Processing payment...');

    try {
      const payTokenData = {
        transaction_type: 'sale',
        amount: this.amount.toString(),
        customer_id: this.debtorDetails?.debtor_id || '',
        name_on_check: `${this.repayAchForm.get('first_name').value} ${this.repayAchForm.get('last_name').value}`,
        ach_account_number: this.repayAchForm.get('account_number').value,
        ach_routing_number: this.repayAchForm.get('routing_number').value,
        ach_account_type: this.repayAchForm.get('account_type').value,
        address_street: this.repayAchForm.get('address_ln1').value,
        address_city: this.repayAchForm.get('address_ln3').value,
        address_state: this.repayAchForm.get('address_town').value,
        address_zip: this.repayAchForm.get('address_postcode').value,
        channel_user: this.repayAchForm.get('channel_user').value,
        source: 'Lateral DAPI',
        payment_method: 'ach',
        payment_channel: 'web',
        save_payment_method: false,
        waive_conv_fee: this.waive_conv_fee || true,
        checkout_form_id: this.checkoutFormId
      };

      const response = await this.caseService.getRepayAchPayToken(payTokenData).toPromise() as RepayApiResponse;

      if (response?.result) {
        this.paytoken = response.result;
        this.commonService.dismissLoader();
        await this.processPayment();
      }
      else {
        this.commonService.showToast(response?.message || 'Failed to get payment token', 'danger');
      }
    }
    catch (error) {
      console.error('Error getting payment token:', error);
      this.commonService.showToast('Failed to process payment token', 'danger');
    }
    finally {
      this.saveBtnDisabled = false;
      this.commonService.dismissLoader();
    }
  }

  async processPayment() {
    this.saveBtnDisabled = true;
    this.commonService.showLoader('Processing payment...');

    try {
      const paymentData = {
        transaction_type: 'sale',
        amount: this.amount.toString(),
        customer_id: this.debtorDetails?.debtor_id || '',
        name_on_check: `${this.repayAchForm.get('first_name').value} ${this.repayAchForm.get('last_name').value}`,
        ach_account_number: this.repayAchForm.get('account_number').value,
        ach_routing_number: this.repayAchForm.get('routing_number').value,
        ach_account_type: this.repayAchForm.get('account_type').value,
        address_street: this.repayAchForm.get('address_ln1').value,
        address_city: this.repayAchForm.get('address_ln3').value,
        address_state: this.repayAchForm.get('address_town').value,
        address_zip: this.repayAchForm.get('address_postcode').value,
        channel_user: this.repayAchForm.get('channel_user').value,
        sec_code: 'TEL',
        source: 'Lateral DAPI',
        payment_method: 'ach',
        payment_channel: 'web',
        save_payment_method: false,
        waive_conv_fee: this.waive_conv_fee || true,
        checkout_form_id: this.checkoutFormId,
        paytoken: this.paytoken
      };

      const response = await this.caseService.makeRepayAchPayment(this.caseId, paymentData).toPromise() as RepayApiResponse;
      console.log(response);
      if (response?.result) {
        this.commonService.showToast('Payment processed successfully!', 'success');
        this.caseService.saveCaseDetails(localStorage.getItem('debtor_id'));
        this.ionNav.popToRoot();
      } else {
        this.commonService.showToast(response?.message || 'Payment failed', 'danger');
      }
    }
    catch (error) {
      console.error('Error processing payment:', error);
      this.commonService.showToast('Failed to process payment', 'danger');
    }
    finally {
      this.saveBtnDisabled = false;
      this.commonService.dismissLoader();
    }
  }

  async dismiss() {
    this.ionNav.pop();
  }
}